<main
  class="ps-page-not-found-main"
  role="region"
  aria-label="Page Not Found"
  data-cy="page-not-found"
>
  <div class="ps-page-not-found-hero" data-cy="page-not-found-hero">
    <img
      class="ps-page-not-found-illustration"
      src="assets/images/404.svg"
      alt="Illustration indicating the requested page was not found"
      loading="lazy"
      decoding="async"
      data-cy="page-not-found-illustration"
    />
    <div
      class="ps-page-not-found-brand"
      aria-label="PureSpectrum"
      data-cy="page-not-found-brand"
    >
      <ps-logo variant="full" size="lg" color="dark" />
    </div>
  </div>
  <h1 class="ps-page-not-found-heading" data-cy="page-not-found-heading">
    Page Not Found
  </h1>
  <p class="ps-page-not-found-description" data-cy="page-not-found-description">
    The page you're looking for doesn't exist or has been moved. Let's get you
    back on track.
  </p>
  <ps-button
    type="button"
    variant="filled"
    color="primary"
    size="md"
    ariaLabel="Return to Home"
    data-cy="page-not-found-return-home"
    (clicked)="onHome()"
  >
    <ps-icon name="house" />
    Return to Home
  </ps-button>
</main>
<ps-footer-copyright
  class="ps-page-not-found-copyright"
  data-cy="page-not-found-footer"
/>
